// ImageZoom.tsx — pass zoomImg separately so zoom uses the full-res src
import { getHighResFileURL, ImageProps } from "./Image.tsx";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css"; // ← make sure this is imported!
import Image from "./Image";
import { IconX } from "@tabler/icons-react";

export const ImageZoom = (props: ImageProps) => {
  const zoomSrc =
    typeof props.src === "string" ? props.src : getHighResFileURL(props.src);

  return (
    <div className="w-full h-full">
      <Zoom
        zoomImg={{ src: zoomSrc, alt: props.alt }}
        IconUnzoom={() => <IconX />}
      >
        <Image {...props} />
      </Zoom>
    </div>
  );
};
export default ImageZoom;
